import StatusTag from "../../components/StatusTag";

// Purchase order statuses: draft | ordered | received | cancelled.
export function statusColor(status) {
  switch(status) {
    case "draft": return StatusTag.COLORS.GREY;
    case "ordered": return StatusTag.COLORS.BLUE;
    case "received": return StatusTag.COLORS.GREEN;
    case "cancelled": return StatusTag.COLORS.RED;
    default: return StatusTag.COLORS.OUTLINE;
  }
}

export function statusLabel(status) {
  switch(status) {
    case "draft": return "Draft";
    case "ordered": return "Ordered";
    case "received": return "Received";
    case "cancelled": return "Cancelled";
    default: return status;
  }
}
